import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import './appHeader.scss';
import AppHeaderLeftContainer from './AppHeaderLeftContainer';
import AppHeaderCenterContainer from './AppHeaderCenterContainer';
import AppHeaderRightContainer from './AppHeaderRightContainer';
import { getAuth } from '../../common/redux/selectors/authInfoSelector';
import { getAssetName } from '../../common/asset-types/redux/selectors/AssetTypesSelectors';

export class AppHeader extends React.Component {
  constructor(props) {
    super(props);

    this.setTitle = this.setTitle.bind(this);
  }

  componentDidMount() {
    this.setTitle();
  }

  componentDidUpdate() {
    this.setTitle();
  }

  setTitle() {
    const { auth: { loggedIn }, appContext } = this.props;
    const { intl } = this.props;

    if (loggedIn && appContext) {
      document.title = intl.formatMessage({ id: 'app.title3' }, { context: appContext });
    } else {
      document.title = intl.formatMessage({ id: 'app.title' });
    }
  }

  render() {
    return (
      <div id="header">
        <AppHeaderLeftContainer />
        <AppHeaderCenterContainer />
        <AppHeaderRightContainer />
      </div>
    );
  }
}

AppHeader.propTypes = {
  auth: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: getAuth(state),
  appContext: getAssetName(state),
});

export default connect(mapStateToProps)(injectIntl(AppHeader));
